import React from 'react';
import Hero from 'components/hero';

const HomeHero = () => {
  return (
    <Hero layout="horizontal" className="bg-dark-blue">
      <div className="text-center">
        <h3>
          MyShifts has been created to free both Health and Social Care Workers
          and Providers from the endless, frustrating and costly interactions
          that come with engaging in the traditional Agency route of finding
          work or employing temporary staff.
        </h3>
        <p>
          We are the future of agency work for the Health and Social Care
          marketplace.
        </p>
        <p>
          Providing faster access to available workers without endless waiting
          for Agency call backs. Enabling Providers to be confident they can
          remain compliant with their staffing levels.
        </p>
      </div>
    </Hero>
  );
};

export default HomeHero;
